import {
  CapabilityPage,
  type CapabilitySection,
} from "@/components/marketing/CapabilityPage";

/**
 * ``/features/naceneni-a-objednavka`` — the core of the product, told
 * the way the other pages of the section tell theirs.
 *
 * Until the 2026-10-07 audit (#61) the hub tile went to the landing on
 * the theory that the whole site already sells quoting. A reader who
 * opened „Co umíme“ to learn how the price is worked out found five
 * pages about everything else and none about that.
 *
 * Every claim here is one the landing and „Jak to funguje“ already
 * make (the rate card, „nic si nedomýšlí“, the machine limits, the
 * „Termín upřesníme“ fallback, „jen na poptávku“, the manual quote by
 * link). This page explains them; it does not add new ones.
 *
 * Only ``custom_operations`` is gated: the operations a shop defines
 * itself, beyond the ready-made ones every tier has.
 *
 * No section carries a ``shot`` yet — ``scripts/feature_shots.py`` has
 * no capture of the customer's configurator. Adding one is a manifest
 * entry and a run of that script; until then the page renders cards
 * only, which is what an unknown shot id would do anyway.
 */
const SECTIONS: readonly CapabilitySection[] = [
  {
    id: "customer",
    items: [
      { id: "upload", wide: true },
      { id: "feasible" },
      { id: "leadTime" },
      { id: "order" },
    ],
  },
  {
    id: "pricing",
    tone: "ink",
    items: [
      { id: "rates", wide: true },
      { id: "missing" },
      { id: "changes" },
      { id: "operations", entitlement: "custom_operations" },
    ],
  },
  {
    id: "manual",
    items: [{ id: "onRequest" }, { id: "noDrawing" }, { id: "quote" }],
  },
];

const PAINS = ["excel", "weekend", "cantMake"] as const;
const GAINS = ["instant", "same", "feasible"] as const;

export default function FeaturesQuoting(): JSX.Element {
  return (
    <CapabilityPage
      i18nKey="features.pages.quoting"
      path="/features/naceneni-a-objednavka"
      pains={PAINS}
      gains={GAINS}
      sections={SECTIONS}
    />
  );
}
